import { Trans } from "@lingui/react/macro";
import {
  BlockContentValue,
  InfographicConfig
} from "@silversea-ssc/ui-components-react";
import { CruiseGroupCode } from "@silversea-ssc/web-cruise-groups";
import { infographicConfigForCruiseGroup } from "src/utils/infographicConfigForCruiseGroup";
import React, { ReactElement } from "react";
import { fareDepositRefundability } from "src/utils/payment-terms-helpers";
import { PaymentTermsResponse } from "src/ssc-api/useRemotePaymentTerms";
import { CruiseGroupPaymentTerms } from "@silversea-ssc/dotcom-api-types/CruiseGroup";
import { RemotePaymentTermFareResponse } from "components/FarePenaltiesModal/helpers";
import { LinguiT } from "src/utils/localization/lingui-helpers";

type Args = {
  t: LinguiT;
  cruiseGroup: CruiseGroupCode | undefined;
  paymentTerms:
    | PaymentTermsResponse
    | RemotePaymentTermFareResponse<CruiseGroupPaymentTerms>
    | undefined;
};

type ComputedFareCardInfo = {
  refundCreditExchangeFooterNotes: string | undefined;
  depositRefundabilityContent: string;
  cancellationPolicyButtonLabel: ReactElement;
  isRefundable: boolean;
  infographicConfig: InfographicConfig;
};

export const computeFareCardInfo = ({
  t,
  cruiseGroup,
  paymentTerms
}: Args): ComputedFareCardInfo => {
  const {
    isRefundable,
    content: depositRefundabilityContent,
    administrativeFeeDisclaimer: refundCreditExchangeFooterNotes
  } = fareDepositRefundability(t, paymentTerms);

  const cancellationPolicyButtonLabel = <Trans>Cancellation Policy</Trans>;

  const infographicConfig = infographicConfigForCruiseGroup(cruiseGroup);

  return {
    infographicConfig,
    isRefundable: isRefundable || false,
    cancellationPolicyButtonLabel,
    depositRefundabilityContent,
    refundCreditExchangeFooterNotes
  };
};

export const extractFareCardHeaderContent = <
  T extends {
    card?: {
      title?: { localized?: string };
      description?: { localized?: string };
    };
    headline?: { localized?: string };
  }
>(
  content: T | undefined
) => {
  return {
    title: content?.card?.title?.localized,
    description: content?.card?.description?.localized,
    headline: content?.headline?.localized
  };
};

export const maybeShowFooterNotesForNonAirCountries = (
  isAirCountry: boolean,
  content: BlockContentValue | undefined
): BlockContentValue | undefined => {
  if (!isAirCountry) return content;

  return undefined;
};
